/*eslint eqeqeq: "off"*/
// React
import React from 'react';

// Components
import Modal2Component from 'shared/components/modal2/Modal2Component';

// Styles
import './PaymentReceiptModalComponent.styles.css';

//i18
import { withTranslation } from 'react-i18next';

// Moment
import * as moment from 'moment';
// Locale
import 'moment/locale/en-au';
import 'moment/locale/es';

function PaymentReceiptModalComponent ( props ) {

    return(
        <Modal2Component
            isOpen={props.isOpen} 
            onClose={props.onClose}
            title={props.t('paymentDetailModal.proofOfPaymentTitle')}
            className="payment-receipt-modal"
        >
            <div className='payment-receipt-modal__container'>
                <div className='payment-receipt-modal__item'>
                    <div className='baloa-table-column'>{props.t('paymentDetailModal.referenceLbl')}</div>
                    <div className='baloa-table'>{props.payment_receipt?.transaction_id}</div>
                </div>
                <div className='payment-receipt-modal__item'>
                    <div className='baloa-table-column'>{props.t('paymentDetailModal.paymentDate')}</div>
                    <div className='baloa-table '>{moment(props.payment_receipt?.payment_date).format('LL')}</div>
                </div>
                <div className='payment-receipt-modal__item'>
                    <div className='baloa-table-column'>{props.t('paymentDetailModal.paymentMethod')}</div>
                    <div className='baloa-table '>{props.t(`paymentDetailModal.paymentMethods.${props.payment_receipt?.method_payment}`)}</div>
                </div>
                <div className='payment-receipt-modal__item'>
                    <div className='baloa-table-column'>{props.t('paymentDetailModal.clientLbl')}</div>
                    <div className='baloa-table '>{props.payment_receipt?.customer}</div>
                </div>
                <div className='payment-receipt-modal__item'>
                    <div className='baloa-table-column'>{props.t('paymentDetailModal.conceptLbl')}</div>
                    <div className='baloa-table '>{props.payment_receipt?.concept}</div>
                </div>
            </div>
        </Modal2Component>
    )
}

export default withTranslation('payments')(PaymentReceiptModalComponent);